import React from 'react';
import { Link } from 'react-router-dom';
import admin from "../images /admin.webp";
import mockup4 from "../images /mockup4.png";
import secure2 from "../images /secure2.png";
import easy4 from "../images /easy4.png";
import trust from "../images /trust.png";



const LandingPage = () => {

  console.log("Admin Image Path:", admin); // ✅ This should be outside return


  return (
    <div className="landing-container">
      {/* 🚀 Hero Section */}
      <div className="landing-hero-section">
          {/* 🚀 Left Side: Text */}
          <div className="landing-hero-text">
            <h1>Effortless Invoicing & Quotes</h1>
            <p>Create professional invoices & quotes in seconds.</p>
            <div className="cta-buttons">
              <Link to="/help" className="btn primary">Get Started</Link>
              <Link to="/login" className="btn secondary">Log In</Link>
            </div>
          </div>

          {/* 🎨 Right Side: Image */}
          {/* <div className="landing-hero-image"></div> */}
          
            <div 
              className="landing-hero-image"
              style={{ backgroundImage: `url(${mockup4})` }}
            ></div>

        </div>


      {/* 💡 Features Section */}
      <div className="features">
        <h2>Why Choose Our Tool?</h2>
        <div className="feature-list">

        <div className="feature-item">
            <img src={secure2} alt="Secure & Reliable" />
            <h3>Secure & Reliable</h3>
            <p>Your data is encrypted and safely stored.</p>
          </div>
          <div className="feature-item">
            <img src={trust} alt="Easy to Use" />
            <h3>Easy to Use</h3>
            <p>Create invoices & quotes in just a few clicks.</p>
          </div>


          <div className="feature-item">
            <img src={easy4} alt="Fast & Efficient" />
            <h3>Fast & Efficient</h3>
            <p>Generate and send invoices instantly.</p>
          </div>
      
         
        </div>
      </div>

      {/* ⭐ Testimonials Section */}
      {/* <div className="testimonials">
        <h2>What Our Users Say</h2>
        <p>⭐ "This tool saved me hours every week!" - Sarah J.</p>
        <p>⭐ "Super simple and professional-looking invoices." - Mark T.</p>
      </div> */}
    </div>
  );
};

export default LandingPage;
